import { render, staticRenderFns } from "./ModalEmail.vue?vue&type=template&id=3907e050&scoped=true&"
import script from "./ModalEmail.vue?vue&type=script&lang=js&"
export * from "./ModalEmail.vue?vue&type=script&lang=js&"
import style0 from "./ModalEmail.vue?vue&type=style&index=0&id=3907e050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3907e050",
  null
  
)

export default component.exports